export default __webpack_public_path__ + "static/media/bannerkitrev.4d84062c.png";